export const REQUIRED = 'Cannot be blank';
export const REQUIRED_SHORT = 'Required';
export const MORE_THAN_ZERO = 'Should be more than 0';
export const POSITIONS_SAME_VAT = 'All positions must have the same vat rate';
export const INVALID_EMAIL = 'Invalid email';
export const INVALID_EMAILS = 'Invalid emails';
export const SOMETHING_WENT_WRONG = 'Something went wrong. Please try again later.';
